import $ from 'jquery';

import { loadEkkoLightboxAsync } from '@/src/utilities/script-loader';

export async function load() {
  if (!document.querySelectorAll('.gallery-image').length) {
    return;
  }

  await loadEkkoLightboxAsync();

  $('[data-toggle="lightbox"]').on('click', function (event) {
    event.preventDefault();

    // @ts-ignore
    $(this).ekkoLightbox();
  });
}
